<template>
    <div>
        <div class="box">
            <div class="top-bar">
                <b-button @click="$router.go(-1)" class="level-item" type="is-light">
                    <b-icon icon="arrow-left" pack="fas" />
                    <span>Back</span>
                </b-button>
                <p class="sub-title">{{ isEdit ? "Edit" : "New" }} {{ itemName }}</p>
            </div>
            <hr />
            <div>
                <form @submit.prevent="formSubmit">
                    <b-field label="ID">
                        <b-input disabled v-model="form.id" />
                    </b-field>

                    <b-tabs type="is-boxed" expanded :animated="false">
                        <b-tab-item
                            v-for="(flag, lang) in {
                                en: { src: '/images/uk.png', t: 'English' },
                                ku: { src: '/images/krd.png', t: 'Kurdish' },
                                ar: { src: '/images/iq.png', t: 'Arabic' },
                            }"
                            :key="lang"
                        >
                            <template #header>
                                <img class="flag" :src="flag.src" />
                                <span> {{ flag.t }} </span>
                            </template>
                            <b-field :message="form.errors.get(`name_${lang}`)" :type="{ 'is-danger': form.errors.has(`name_${lang}`) }" expanded>
                                <template slot="label"> Title {{ flag.t }} </template>
                                <b-input :placeholder="`Title ${flag.t}`" type="text" v-model="form[`name_${lang}`]" />
                            </b-field>
                            <b-field
                                :message="form.errors.get(`position_${lang}`)"
                                :type="{ 'is-danger': form.errors.has(`position_${lang}`) }"
                                expanded
                            >
                                <template slot="label"> Position {{ flag.t }} </template>
                                <b-input :placeholder="`Position ${flag.t}`" type="text" v-model="form[`position_${lang}`]" />
                            </b-field>
                            <b-field
                                :message="form.errors.get(`details.desc_${lang}`)"
                                :type="{ 'is-danger': form.errors.has(`details.desc_${lang}`) }"
                                expanded
                            >
                                <template slot="label"> Description {{ flag.t }} </template>
                                <b-input
                                    :placeholder="`Description ${flag.t}`"
                                    type="textarea"
                                    v-model="form.details[`desc_${lang}`]"
                                    maxlength="1000"
                                />
                            </b-field>
                        </b-tab-item>
                    </b-tabs>

                    <!-- Gallery File Selection -->
                    <b-field
                        :message="form.errors.get('image_id')"
                        :type="{ 'is-danger': form.errors.has('image_id') }"
                        expanded
                        label="Profile Image"
                    >
                        <GalleryPicker :multiple="false" type="image" @select="(id) => (form.image_id = id)" :initial="form.image" />
                    </b-field>

                    <b-field
                        :message="form.errors.get('details.linkedin')"
                        :type="{ 'is-danger': form.errors.has('details.linkedin') }"
                        expanded
                        label="Linked-In Porfile URL"
                    >
                        <b-input v-model="form.details.linkedin" maxlength="100" placeholder="Linked-In Profile URL" />
                    </b-field>

                    <b-field
                        :message="form.errors.get('details.email')"
                        :type="{ 'is-danger': form.errors.has('details.email') }"
                        expanded
                        label="Email"
                    >
                        <b-input v-model="form.details.email" maxlength="50" placeholder="Email" />
                    </b-field>

                    <b-field :message="form.errors.get('type')" :type="{ 'is-danger': form.errors.has('type') }" expanded label="Staff Type">
                        <b-select v-model="form.type" required expanded>
                            <option value="staff">Staff</option>
                            <option value="volunteer">Volunteer</option>
                            <option value="scholars">Scholars</option>
                        </b-select>
                    </b-field>

                    <b-field :message="form.errors.get('sort')" :type="{ 'is-danger': form.errors.has('sort') }" expanded label="Sort">
                        <b-input v-model="form.sort" type="number" maxlength="100" placeholder="Sort" />
                    </b-field>

                    <div class="bottom-btns">
                        <b-button @click="$router.go(-1)" type="is-light">Cancel</b-button>
                        <b-button :loading="form.busy" native-type="submit" type="is-primary">Submit</b-button>
                    </div>
                </form>
                <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
            </div>
        </div>
    </div>
</template>

<script>
import vform from "../../../plugins/vForm";
import GalleryPicker from "../../../components/Files/GalleryPicker.vue";
export default {
    components: {
        GalleryPicker,
    },
    data() {
        return {
            itemName: "Staff",
            apiURI: "/staff",
            isLoading: true,
            form: new vform({
                id: "",
                name_en: "",
                name_ar: "",
                name_ku: "",
                position_en: "",
                position_ar: "",
                position_ku: "",
                details: {
                    desc_en: "",
                    desc_ar: "",
                    desc_ku: "",
                    linkedin: "",
                    email: "",
                },
                type: "staff",
                image_id: "",
                image: null,
                sort: 0,
            }),
        };
    },
    methods: {
        async init() {
            let id = this.$route.params.id;
            // Edit Loading
            if (this.isEdit) {
                // If its not Number
                if (!id || !this.isNumber(id)) {
                    this.notify("Error fetching data.", "is-danger");
                    return;
                }
                try {
                    let res = await this.$http.get(`${this.apiURI}/${id}`);
                    res.data.details = res.data.details ?? {};
                    this.form.fill(res.data);
                } catch (err) {
                    this.notify(err, "is-danger");
                    return;
                }
            }
            this.isLoading = false;
        },
        formSubmit() {
            if (this.isEdit) {
                // Edit request
                let update = () => {
                    this.form
                        .submit("post", this.apiURI + "/" + this.form.id)
                        .then(() => {
                            //Alert
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.itemName + " editied successfully.",
                                type: "is-success",
                            });
                            this.$router.go(-1);
                            // this.$store.dispatch("loadAPI", this.$axios);
                        })
                        .catch((err) => {
                            if (err.response.status != 422) {
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: "Something went wrong.",
                                    position: "is-bottom",
                                    type: "is-danger",
                                });
                            }
                        });
                };
                update();
            } else {
                // Create request
                this.form
                    .submit("post", this.apiURI)
                    .then(() => {
                        //Alert
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: this.itemName + " created successfully.",
                            type: "is-success",
                        });
                        this.$router.go(-1);
                        // this.$store.dispatch("loadAPI", this.$axios);
                    })
                    .catch((err) => {
                        if (err.response.status != 422) {
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: "Something went wrong. Please try again.",
                                position: "is-bottom",
                                type: "is-danger",
                            });
                        }
                    });
            }
        },
    },
    created() {},
    mounted() {
        this.init();
    },
    computed: {
        isEdit() {
            if (this.$route.path.indexOf("new") == -1) {
                return true;
            }
            return false;
        },
    },
};
</script>

<style>
.block {
    display: block;
}
.modal-form {
    position: relative;
}
img.preview-image {
    max-height: 180px;
    border-radius: 10px;
}
</style>
